<template>
  <header class="topbar">
    <div class="crumb">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/></svg>
      <span>{{ crumbRoot }}</span>
      <span class="sep">/</span>
      <b>{{ pageTitle }}</b>
    </div>

    <div class="topbar-spacer"></div>

    <router-link to="/profile" class="ws" :title="t('nav.profile')">
      <UserAvatar :user="userForAvatar" :size="32" class="ws-av-tile" />
      <div class="ws-info">
        <div class="ws-name">{{ user?.name }}</div>
        <div class="ws-role">{{ roleLabel }}</div>
      </div>
    </router-link>
  </header>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import { useI18n } from '@/composables/useI18n'
import UserAvatar from '@/components/UserAvatar.vue'

const TITLES = {
  dashboard: 'nav.dashboard', tasks: 'nav.tasks', calendar: 'nav.calendar', projects: 'nav.projects',
  team: 'nav.team', clients: 'nav.clients', requests: 'nav.requests', reports: 'nav.reports',
  'c-dashboard': 'portal.navOverview', 'c-projects': 'portal.navProjects', 'c-project': 'portal.navProjects',
  'c-requests': 'portal.navRequests', 'c-reports': 'portal.navReports',
}

export default {
  name: 'AppTopbar',
  components: { UserAvatar },
  setup() {
    const route = useRoute()
    const { currentUser, isExternalClient, isManager } = useAuth()
    const { t } = useI18n()

    const user = computed(() => currentUser())
    const pageTitle = computed(() => t(TITLES[route.name] || 'nav.dashboard'))
    const crumbRoot = computed(() => 'PICO DEV')
    const roleLabel = computed(() => isExternalClient() ? t('roles.client') : (isManager() ? t('roles.manager') : t('roles.developer')))
    const initials = computed(() => (user.value?.name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase())

    const userForAvatar = computed(() => ({
      id:           user.value?.id,
      name:         user.value?.name,
      avatar_url:   user.value?.avatar_url,
      avatar_color: user.value?.avatar_color,
    }))

    return { t, user, userForAvatar, pageTitle, crumbRoot, roleLabel, initials }
  },
}
</script>

<style scoped>
.topbar { height: var(--topbar-h, 64px); display: flex; align-items: center; gap: 12px; padding: 0 4px; }
.crumb .sep { color: var(--ink-3); margin: 0 2px; }
.topbar-spacer { flex: 1; }
.ws { display: flex; align-items: center; gap: 9px; padding: 4px 6px 4px 4px; border: 1px solid var(--glass-brd); border-radius: 12px; background: var(--glass); color: inherit; text-decoration: none; transition: background .15s; }
.ws:hover { background: var(--hover, var(--glass)); }
.ws-av-tile { border-radius: 9px !important; }
.ws-name { font-size: 12.5px; font-weight: 700; line-height: 1.1; color: var(--ink); }
.ws-role { font-size: 11px; color: var(--ink-2); margin-top: 1px; }
@media (max-width: 768px) { .topbar { display: none; } }
</style>
